import React from "react";
import AuditFormSubQuestionUi from "./AuditFormSubQuestionUi";
function AuditFormSunQuestion({
  formik,
  handleSubQuestionChange,
  removeSubQuetionField,
  addNewSubQuetionField,
  addSubQuestonOptionField,
  removeSubQuestionOptionsField,
  handleSubQuetionsOptionsChange,
  subQuestionErrors,
  id
}) {
  return (
    <AuditFormSubQuestionUi
      formik={formik}
      handleSubQuestionChange={handleSubQuestionChange}
      removeSubQuetionField={removeSubQuetionField}
      addNewSubQuetionField={addNewSubQuetionField}
      addSubQuestonOptionField={addSubQuestonOptionField}
      removeSubQuestionOptionsField={removeSubQuestionOptionsField}
      handleSubQuetionsOptionsChange={handleSubQuetionsOptionsChange}
      subQuestionErrors={subQuestionErrors}
      id={id}
    />
  );
}

export default AuditFormSunQuestion;
